module.exports = __webpack_public_path__ + "static/media/userTokenDashedLine.6e4599fa.svg";